import axios from 'axios';

export default {
    addLoadingTask({commit}, payload) {
        commit('addLoadingTask', payload);
    },
    removeLoadingTask({commit}, payload) {
        commit('removeLoadingTask', payload);
    },
    updateErrors({commit}, payload) {
        commit('updateErrors', payload);
    },
    /**
     * get all product for search
     * @param commit
     * @returns {Promise.<TResult>|Promise<any>}
     */
    getAllProducts({commit}) {
        return axios.get(window.apiEndpoints['product.all']).then(res => {
            if(res.status === 200) {
                commit('updateAllProducts', {allProducts: res.data.data.products});
            }
        })
    },
    /**
     * get coming holidays from api and fetch it to the store
     * @param commit
     * @param dispatch
     */
    getHolidays({commit, dispatch}) {
        const task = 'getHolidays';
        if(this.state.loadingTasks.indexOf(task) > 0) {return;}
        dispatch('addLoadingTask', {task}, {root:true});
        return axios.get(window.apiEndpoints['holiday.upcoming.all']).then(res => {
            if(res.status === 200) {
                commit('updateHolidays', res.data.data.upcoming_holidays)
                dispatch('removeLoadingTask', {task}, {root:true});
            }
        })
    },
};